/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Step3Scenarios } from './Step3Scenarios';
import {
    Step3ScenariosFromJSON,
    Step3ScenariosFromJSONTyped,
    Step3ScenariosToJSON,
} from './Step3Scenarios';
import type { Step5SubSteps } from './Step5SubSteps';
import {
    Step5SubStepsFromJSON,
    Step5SubStepsFromJSONTyped,
    Step5SubStepsToJSON,
} from './Step5SubSteps';
import type { StepStateType } from './StepStateType';
import {
    StepStateTypeFromJSON,
    StepStateTypeFromJSONTyped,
    StepStateTypeToJSON,
} from './StepStateType';

/**
 * 
 * @export
 * @interface StateModel
 */
export interface StateModel {
    /**
     * 
     * @type {StepStateType}
     * @memberof StateModel
     */
    step1: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof StateModel
     */
    step2: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof StateModel
     */
    step3: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof StateModel
     */
    step4: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof StateModel
     */
    step5: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof StateModel
     */
    step6: StepStateType;
    /**
     * 
     * @type {Step5SubSteps}
     * @memberof StateModel
     */
    step5SubSteps: Step5SubSteps;
    /**
     * 
     * @type {Array<Step3Scenarios>}
     * @memberof StateModel
     */
    step3Scenarios: Array<Step3Scenarios>;
}

/**
 * Check if a given object implements the StateModel interface.
 */
export function instanceOfStateModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "step1" in value;
    isInstance = isInstance && "step2" in value;
    isInstance = isInstance && "step3" in value;
    isInstance = isInstance && "step4" in value;
    isInstance = isInstance && "step5" in value;
    isInstance = isInstance && "step6" in value;
    isInstance = isInstance && "step5SubSteps" in value;
    isInstance = isInstance && "step3Scenarios" in value;

    return isInstance;
}

export function StateModelFromJSON(json: any): StateModel {
    return StateModelFromJSONTyped(json, false);
}

export function StateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'step1': StepStateTypeFromJSON(json['Step1']),
        'step2': StepStateTypeFromJSON(json['Step2']),
        'step3': StepStateTypeFromJSON(json['Step3']),
        'step4': StepStateTypeFromJSON(json['Step4']),
        'step5': StepStateTypeFromJSON(json['Step5']),
        'step6': StepStateTypeFromJSON(json['Step6']),
        'step5SubSteps': Step5SubStepsFromJSON(json['Step5SubSteps']),
        'step3Scenarios': ((json['Step3Scenarios'] as Array<any>).map(Step3ScenariosFromJSON)),
    };
}

export function StateModelToJSON(value?: StateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Step1': StepStateTypeToJSON(value.step1),
        'Step2': StepStateTypeToJSON(value.step2),
        'Step3': StepStateTypeToJSON(value.step3),
        'Step4': StepStateTypeToJSON(value.step4),
        'Step5': StepStateTypeToJSON(value.step5),
        'Step6': StepStateTypeToJSON(value.step6),
        'Step5SubSteps': Step5SubStepsToJSON(value.step5SubSteps),
        'Step3Scenarios': ((value.step3Scenarios as Array<any>).map(Step3ScenariosToJSON)),
    };
}

